import { createSlice } from "@reduxjs/toolkit";
import { retrieveStoredToken } from "../utils/AuthUtils";

// import { persistor } from "../store";

export type AuthState = {
  token: string | null;
  isLoggedIn: false;
  login: (token: string) => {};
  logout: () => {};
  logoutTimer: null;
  userName: string;
};

const authSlice = createSlice({
  name: "auth",
  initialState: {
    token: retrieveStoredToken() ? retrieveStoredToken() : "",
    isLoggedIn: false,
    userName: "",
    login: (token: string) => {},
    logout: () => {},
    logoutTimer: null,
  },
  reducers: {
    logout(state) {
      console.log("logging out now");
      state.token = "";
      state.isLoggedIn = false;
      state.userName = "";
      if (state.logoutTimer) {
        clearTimeout(state.logoutTimer);
        state.logoutTimer = null;
      }
      // Clear the persisted state
      // persistor.purge().then(() => {
      //   console.log('Persisted state has been cleared on logout');
      // });
    },
    signup(state, action) {
      console.log(state);
      console.log(action);
    },
    login(state, action) {
      state.isLoggedIn = true;
      const { token } = action.payload;
      state.token = token;
      state.userName = action.payload.userName;
    },
    setLogoutTimer(state, action) {
      state.logoutTimer = action.payload;
    },
    clearLogoutTimer(state) {
      if (state.logoutTimer) {
        clearTimeout(state.logoutTimer);
        state.logoutTimer = null;
      }
    },
  },
});

export const authActions = authSlice.actions;

export default authSlice;
